import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import StatsBar from "../components/StatsBar";
import HighlightedProjects from "../components/HighlightedProjects";
import BrandsStrip from "../components/BrandsStrip";
import Toolkit from "../components/Stack";
import Work from "../components/Work";
import Expertise from "../components/Expertise";
import DesignShots from "../components/DesignShots";
import About from "../components/About";
import Testimonials from "../components/Testimonials";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import { usePublicData } from "../hooks/usePublicData";

const LoadingScreen = () => (
  <div className="min-h-screen grid place-items-center" style={{ backgroundColor: "var(--bg)" }}>
    <div className="text-center">
      <div className="font-display text-3xl">Misbah.</div>
      <div className="mt-2 text-sm text-[color:var(--muted)]">Loading…</div>
    </div>
  </div>
);

const Portfolio = () => {
  const { site, about, projects, testimonials, loading, error } = usePublicData();

  if (loading) return <LoadingScreen />;
  if (error || !site) {
    return (
      <div
        className="min-h-screen grid place-items-center px-6 text-center"
        style={{ backgroundColor: "var(--bg)" }}
      >
        <div>
          <div className="font-display text-2xl mb-2">Couldn&apos;t load the site</div>
          <div className="text-sm text-[color:var(--muted)]">Please refresh in a moment.</div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen" style={{ backgroundColor: "var(--bg)" }} data-testid="portfolio-root">
      <Header site={site} />
      <main>
        <Hero site={site} about={about} />
        <StatsBar stats={site.stats} />
        <HighlightedProjects projects={projects} />
        <BrandsStrip brands={site.brands} />
        <Toolkit site={site} />
        <Work projects={projects} />
        <Expertise site={site} />
        <DesignShots shots={site.design_shots} />
        <About about={about} site={site} />
        <Testimonials testimonials={testimonials} />
        <Contact site={site} />
      </main>
      <Footer site={site} />
    </div>
  );
};

export default Portfolio;
